import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { WarehouseService } from 'src/app/Services/WareHouse/warehouse.service';

import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  EWarehouseActions,
  CreateReleaseMaterialProducts,
  CreateReceiveProducts,
  GetAllRejectMaterialsSuccess,
  GetAllRejectMaterials,
  AddRejectMaterial,
  AddRejectProduct,
  AddReturnMaterial,
  EditReturnMaterial,
  GetMlos,
  GetRecLotsByMaterialID,
  EditRejectMaterial_product,
  GetRecProductsByFormulaID,
  EditReceiveProduct,
  UpdateSohValue,
  GetReceivedQtyByFormulaId,
  GetMiscellaneousReasons,
  AddMiscellaneousReason,
  GetRecLotsByMaterialIDList
} from '../actions/warehouse.action';

@Injectable()
export class WarehouseEffects {

    createRMP$ = createEffect(() => this.actions$.pipe(
        ofType<CreateReleaseMaterialProducts>(EWarehouseActions.CreateReleaseMaterialProducts),
        map(action => action.payload),
        mergeMap((payload : any) => this.warehouseService.createReleaseMaterialProduct(payload)
        .pipe(map((result: any) => ({ type: '[ReleaseMaterialProducts] Set Create ReleaseMaterialProducts Success', payload: result })),
          catchError((err) => of({ type: '[ReleaseMaterialProducts] Set Create ReleaseMaterialProducts Error', payload:err}))
        )
      )
    ));


    createReceiveProduct$ = createEffect(() => this.actions$.pipe(
        ofType<CreateReceiveProducts>(EWarehouseActions.CreateReceiveProducts),
        map(action => action.payload),
        mergeMap((payload : any) => this.warehouseService.createReceiveProduct(payload)
        .pipe(map((result: any) => ({ type: '[ReceiveProducts] Set Create ReceiveProducts Success', payload: result })),
          catchError((err) => of({ type: '[ReceiveProducts] Set Create ReceiveProducts Error', payload:err}))
        )
      )
    ));

    editReceiveProduct$ = createEffect(() => this.actions$.pipe(
        ofType<EditReceiveProduct>(EWarehouseActions.EditReceiveProduct),
        map(action => action.payload),
        mergeMap((payload : any) => this.warehouseService.editReceiveProduct(payload)
        .pipe(map((result: any) => ({ type: '[ReceiveProducts] Get Edit ReceiveProduct Success', payload: result })),
          catchError((err) => of({ type: '[] Get Edit ReceiveProduct Error', payload:err}))
        )
      )
    ));

   getAllRejectmaterials$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllRejectMaterials>(EWarehouseActions.GetAllRejectMaterials),
        map(action => action.payload),
        mergeMap((payload : any) => this.warehouseService.getAllRejectMaterials(payload)
        .pipe(map((result: any) => ({ type: '[RejectMaterials] Get All Reject Materials Success', payload: result })),
          catchError((err) => of({ type: '[RejectMaterials] Get All Reject Materials Error', payload:err}))
        )
      )
    ));

   addRejectmaterial$ = createEffect(() => this.actions$.pipe(
         ofType<AddRejectMaterial>(EWarehouseActions.AddRejectMaterial),
         map(action => action.payload),
         mergeMap((payload : any) => this.warehouseService.addRejectMaterial(payload)
         .pipe(map((result: any) => ({ type: '[RejectMaterials] Add Reject Material Success', payload: result })),
           catchError((err) => of({ type: '[RejectMaterials] Add Reject Material Error', payload:err}))
         )
       )
     ));

     addRejectproduct$ = createEffect(() => this.actions$.pipe(
           ofType<AddRejectProduct>(EWarehouseActions.AddRejectProduct),
           map(action => action.payload),
           mergeMap((payload : any) => this.warehouseService.addRejectProduct(payload)
           .pipe(map((result: any) => ({ type: '[RejectProducts] Add Reject Product Success', payload: result })),
             catchError((err) => of({ type: '[RejectProducts] Add Reject Product Error', payload:err}))
           )
         )
       ));

       editRejectMaterial_prod$ = createEffect(() => this.actions$.pipe(
             ofType<EditRejectMaterial_product>(EWarehouseActions.EditRejectMaterial_product),
             map(action => action.payload),
             mergeMap((payload : any) => this.warehouseService.editRejectMaterial_product(payload)
             .pipe(map((result: any) => ({ type: '[RejectMaterials] Edit Reject Material Success', payload: result })),
               catchError((err) => of({ type: '[RejectMaterials] Edit Reject Material Error', payload:err}))
             )
           )
         ));
        //
        //  editRejectProduct$ = createEffect(() => this.actions$.pipe(
        //        ofType<EditRejectProduct>(EWarehouseActions.EditRejectProduct),
        //        map(action => action.payload),
        //        mergeMap((payload : any) => this.warehouseService.editRejectProduct(payload)
        //        .pipe(map((result: any) => ({ type: '[RejectMaterials] Edit Reject Product Success', payload: result })),
        //          catchError((err) => of({ type: '[RejectMaterials] Edit Reject Product Error', payload:err}))
        //        )
        //      )
        //    );

        getMlos$ = createEffect(() => this.actions$.pipe(
               ofType<GetMlos>(EWarehouseActions.GetMlos),
               map(action => action.payload),
               mergeMap((payload : any) => this.warehouseService.getMlos(payload)
               .pipe(map((result: any) => ({ type: '[RejectMaterials] Get Mlos Success', payload: result })),
                 catchError((err) => of({ type: '[RejectMaterials] Get Mlos Error', payload:err}))
               )
             )
           ));

              getRecLotsByMaterialID$ = createEffect(() => this.actions$.pipe(
               ofType<GetRecLotsByMaterialID>(EWarehouseActions.GetRecLotsByMaterialID),
               map(action => action.payload),
               mergeMap((payload : any) => this.warehouseService.getRecLots(payload)
               .pipe(map((result: any) => ({ type: '[RejectMaterials] Get RecLots Success', payload: result })),
                 catchError((err) => of({ type: '[RejectMaterials] Get RecLots Error', payload:err}))
               )
             )
           ));

              getRecLotsByMaterialIDList$ = createEffect(() => this.actions$.pipe(
               ofType<GetRecLotsByMaterialIDList>(EWarehouseActions.GetRecLotsByMaterialIDList),
               map(action => action.payload),
               mergeMap((payload: any) => this.warehouseService.getRecLotsList(payload)
               .pipe(map((result: any) => ({ type: '[RejectMaterials] Get RecLotsList Success', payload: result })),
                 catchError((err) => of({ type: '[RejectMaterials] Get RecLotsList Error', payload: err}))
               )
             )
           ));

        addReturnMaterial$ = createEffect(() => this.actions$.pipe(
               ofType<AddReturnMaterial>(EWarehouseActions.AddReturnMaterial),
               map(action => action.payload),
               mergeMap((payload : any) => this.warehouseService.addReturnMaterial(payload)
               .pipe(map((result: any) => ({ type: '[ReturnMaterial] Add Return Material Success', payload: result })),
                 catchError((err) => of({ type: '[ReturnMaterial] Add Return Material Error', payload:err}))
               )
             )
           ));

           editReturnMaterial$ = createEffect(() => this.actions$.pipe(
                  ofType<EditReturnMaterial>(EWarehouseActions.EditReturnMaterial),
                  map(action => action.payload),
                  mergeMap((payload : any) => this.warehouseService.editReturnMaterial(payload)
                  .pipe(map((result: any) => ({ type: '[ReturnMaterial] Edit Return Material Success', payload: result })),
                    catchError((err) => of({ type: '[ReturnMaterial] Edit Return Material Error', payload:err}))
                  )
                )
              ));

          getRecProductByFormulaId$ = createEffect(() => this.actions$.pipe(
                  ofType<GetRecProductsByFormulaID>(EWarehouseActions.GetRecProductsByFormulaID),
                  map(action => action.payload),
                  mergeMap((payload : any) => this.warehouseService.getRecProductByFormulaId(payload)
                  .pipe(map((result: any) => ({ type: '[ReceiveProducts] Get ReceiveProducts By Formula Id Success', payload: result })),
                    catchError((err) => of({ type: '[ReceiveProducts] Get ReceiveProducts By Formula Id Error', payload:err}))
                  )
                )
              ));


              updateSohValue$ = createEffect(() => this.actions$.pipe(
                      ofType<UpdateSohValue>(EWarehouseActions.UpdateSohValue),
                      map(action => action.payload),
                      mergeMap((payload : any) => this.warehouseService.updateSohValue(payload)
                      .pipe(map((result: any) => ({ type: '[checkmat] Get Update SOH Value Success', payload: result })),
                        catchError((err) => of({ type: '[checkmat] Get Update SOH Value Error', payload:err}))
                      )
                    )
                  ));

                  getReceivedQtyByFormulaId$ = createEffect(() => this.actions$.pipe(
                          ofType<GetReceivedQtyByFormulaId>(EWarehouseActions.GetReceivedQtyByFormulaId),
                          map(action => action.payload),
                          mergeMap((payload : any) => this.warehouseService.getReceivedQtyByFormulaId(payload)
                          .pipe(map((result: any) => ({ type: '[ReceiveProducts] Get Received Qty By FormulaId Success', payload: result })),
                            catchError((err) => of({ type: '[] Get Received Qty By FormulaId Error', payload:err}))
                          )
                        )
                      ));



                      getMiscellaneousReasons$ = createEffect(() => this.actions$.pipe(
                              ofType<GetMiscellaneousReasons>(EWarehouseActions.GetMiscellaneousReasons),
                              map(action => action.payload),
                              mergeMap((payload : any) => this.warehouseService.getMiscellaneousReasons(payload)
                              .pipe(map((result: any) => ({ type: '[MiscellaneousReasons] Get MiscellaneousReasons Success', payload: result })),
                                catchError((err) => of({ type: '[] Get MiscellaneousReasons Error', payload:err}))
                              )
                            )
                          ));


                      addMiscellaneousReason$ = createEffect(() => this.actions$.pipe(
                              ofType<AddMiscellaneousReason>(EWarehouseActions.AddMiscellaneousReason),
                              map(action => action.payload),
                              mergeMap((payload : any) => this.warehouseService.addMiscellaneousReason(payload)
                              .pipe(map((result: any) => ({ type: '[MiscellaneousReasons] Add MiscellaneousReason Success', payload: result })),
                                catchError((err) => of({ type: '[] Add MiscellaneousReason Error', payload:err}))
                              )
                            )
                          ));
    constructor(private actions$: Actions,
        private store: Store<IAppState>,
        private warehouseService:WarehouseService
    ){}







}
